import React, { useState, useEffect, CSSProperties } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";
import SplInstructionsModal from "./SplInstructionsModal";
import { APPOINTMENT_ACTIONS } from "../common/EventConstant";
import { RootState } from "../redux/Store";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsDashboard,
  setNewCaseInFoID,
} from "../redux/slice/CaseHeaderSlice";
import {
  CASE_STAGE_STATUS,
  HISTORY_REPORT_STATUS,
  QME_APPOINTMENT_STATUS,
} from "./Constant";

// Define the DataTableProps interface
interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;

  isLogTable?: boolean;

  radioSelection?: boolean;
  onRadioSelect?: (row: any) => void; // ✅ This line
  onRowSelect?: (row: any) => void;

  selectedCaseId?: number | null;
  onSelectCase?: (id: number) => void;
  onInvalidSelection?: (caseStage: string) => void;
  onCaseClick?: any;
}

const HistorianDataTable: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,

  isLogTable = false,

  radioSelection = false,
  onRadioSelect,

  selectedCaseId,
  onSelectCase,
  onInvalidSelection,
  onCaseClick,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);
 const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return; // Prevent clicking on the same active sort direction
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };

  const dispatch = useDispatch();

  const [visibleHeaderIndex, setVisibleHeaderIndex] = useState<boolean>(false);

  const NON_SELECTABLE_STAGES = [
    CASE_STAGE_STATUS.CLOSED,
    CASE_STAGE_STATUS.CANCELLED,
  ];

  return (
    <>
      <div className="table-responsive border-0 mb-2">
        <Table className="historianTab">
          <thead>
            <tr>
              {radioSelection && <th style={{ width: "10%" }} />}

              {headers.map((header) => (
                // <th key={header.key} style={thStyle}>
                <th
                  key={header.key}
                  style={{
                    border: "none",
                    padding: "8px",
                    backgroundColor: "#e0f7fa",
                    color: "#000",
                    cursor: header.sortable ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: -90,

                    textAlign: [
                      "isActiveDetails",
                      "appointmentStatusDesc",
                      "actions",
                      "phonenumber",
                      "download",
                      "downloadFile",
                    ].includes(header.key)
                      ? "center"
                      : "left",
                    ...header.style,
                  }}
                >
                  <div
                    style={{
                      display: [
                        "isActiveDetails",
                        "appointmentStatusDesc",
                        "actions",
                        "phonenumber",
                        "contactphonenumber",
                        "download",
                        "downloadFile",
                      ].includes(header.key)
                        ? "flex"
                        : "flex",

                      justifyContent: [
                        "isActiveDetails",
                        "appointmentStatusDesc",
                        "actions",
                        "phonenumber",
                        "contactphonenumber",
                        "download",
                        "downloads",
                        "downloadFile",
                      ].includes(header.key)
                        ? "space-evenly"
                        : "space-between",

                      alignItems: "center",
                    }}
                  >
                    <span>{header.label}</span>
                    {header.sortable && (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "4px",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0px",
                        }}
                      >
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "ASC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "ASC")}
                            >
                              arrow_drop_up
                            </span>
                          )}
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "DESC"
                        ) && (
                            <span
                              className="material-icons"
                              style={{
                                fontSize: "18px",
                                lineHeight: "10px",
                              }}
                              onClick={() => handleSort(header.key, "DESC")}
                            >
                              arrow_drop_down
                            </span>
                          )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.length > 0 ? (
              rows.map((row, index) => (
                <tr
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                    position: "sticky",
                  }}
                >
                  {radioSelection && (
                    <td>
                      <input
                        type="radio"
                        name="rowSelect"
                        value={row.subjectQmeScheduleID}
                        checked={selectedCaseId === row.subjectQmeScheduleID}
                        onChange={() => {
                          if (NON_SELECTABLE_STAGES.includes(row.caseStage)) {
                            onInvalidSelection?.(row.caseStage);
                            return;
                          }

                          onSelectCase?.(row.subjectQmeScheduleID);
                        }}
                         disabled={row.assignedUserID !== loggedInUserid }
                      // disabled={NON_SELECTABLE_STAGES.includes(row.caseStage)}
                      />
                    </td>
                  )}

                  {headers.map((header) => {
                    if (header.key === "actions") {
                      return (
                        <td
                          key={header.key}
                          style={{ padding: "8px", textAlign: "center" }}
                        >
                          {row.actions?.View && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`view-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  View
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "View")}
                                style={{ cursor: "pointer" }}
                              >
                                visibility
                              </span>
                            </OverlayTrigger>
                          )}
                          {row.actions?.Edit && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`edit-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  Edit
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "Edit")}
                                style={{ cursor: "pointer" }}
                              >
                                edit
                              </span>
                            </OverlayTrigger>
                          )}
                        </td>
                      );
                    }

                    const cellContent = row[header.key];

                    const isStatusColumn =
                      header.key === "historianStatusDesc" ||
                      header.key === "appointmentStatus";

                    const getStatusColor = (status: string) => {
                      switch (status) {
                        case HISTORY_REPORT_STATUS.OVERDUE:
                        case QME_APPOINTMENT_STATUS.CANCELLED:
                        case HISTORY_REPORT_STATUS.CANCELLED:
                          return "#FF0000";

                        case HISTORY_REPORT_STATUS.DRAFT:
                          return "#fcaa13ff";

                        case HISTORY_REPORT_STATUS.EXCEPTION:
                          return "#fc7013ff";

                        case HISTORY_REPORT_STATUS.PENDING:
                        case QME_APPOINTMENT_STATUS.SCHEDULED:
                          return "#10a5ebff";

                        case QME_APPOINTMENT_STATUS.PATIENT_NO_SHOW:
                        case QME_APPOINTMENT_STATUS.RESCHEDULED:
                        case QME_APPOINTMENT_STATUS.PATIENT_CHECKED_IN:
                        case QME_APPOINTMENT_STATUS.QME_REQUESTED_RESCHEDULE:
                          return "#1b5975f8";

                        case HISTORY_REPORT_STATUS.COMPLETED:
                        case HISTORY_REPORT_STATUS.Completed_Delayed:
                        case QME_APPOINTMENT_STATUS.COMPLETED:
                          return "#0E8536";

                        default:
                          return "#000000";
                      }
                    };

                    if (header.key === "patientName") {
                      const cellContent = row[header.key];
                      return (
                        <td key={header.key}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                cellContent && cellContent?.length > 10 ? (
                                  <Tooltip
                                    id={`tooltip-${header.key}-${row.id}`}
                                    style={{ backgroundColor: "#b3e0ff" }}
                                  >
                                    {cellContent}
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span
                                className="d-inline-block text-truncate"
                                style={{
                                  // maxWidth: "calc(100% - 8px)",
                                  cursor: "pointer",
                                  width: "95%",
                                  color: "#007bff",
                                }}
                              >
                                <a
                                  href="#/search-case"
                                  style={{
                                    textDecoration: "none",
                                    color: "inherit",
                                  }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    onCaseClick(row);
                                  }}
                                >
                                  {cellContent}
                                </a>
                              </span>
                            </OverlayTrigger>
                          </div>
                        </td>
                      );
                    }
                    return (
                      <td
                        key={header.key}
                        style={{
                          padding: header.isNumeric
                            ? "8px 20px 8px 8px !important"
                            : "8px",
                          textAlign: header.isNumeric ? "center" : "left",
                        }}
                      >
                        <OverlayTrigger
                          placement="auto"
                          delay={{ show: 200, hide: 10 }}
                          overlay={
                            cellContent &&
                              cellContent?.length > (isLogTable ? 60 : 8) ? (
                              <Tooltip
                                id={`tooltip-${header.key}-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                {cellContent}
                              </Tooltip>
                            ) : (
                              <></>
                            )
                          }
                        >
                          <span
                            // className= 'd-inline-block text-truncate'
                            className={`d-inline-block ${!isLogTable ? "text-truncate" : ""
                              }`}
                            style={{
                              maxWidth: isLogTable ? "none" : "98%",
                              cursor: isLogTable ? "default" : "pointer",
                              color: isStatusColumn
                                ? getStatusColor(cellContent)
                                : undefined,
                            }}
                          >
                            {cellContent === "1/1/1970 05:30 AM"
                              ? ""
                              : cellContent}
                          </span>
                        </OverlayTrigger>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                  <span className="no_rec_data">No Record Found</span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default HistorianDataTable;
